import mailStore from "owa-mail-store/lib/store/Store";
import { mutatorAction } from "satcheljs";

export const updateShouldExpandAllItemPartsMutator: (shouldExpandAll: boolean) => void = mutatorAction("updateShouldExpandAllItemPartsMutator", (shouldExpandAll: boolean): void => {
    mailStore().shouldExpandAllItemParts = shouldExpandAll;
});
